import {DATASET_MIXPANEL} from 'common/report/constants';

import {BaseClient} from '../utils/base-client';
import {getEventParam, processProperties} from './utils';

class EventPropertiesClient extends BaseClient {
  buildEndpoint() {
    return `api/2.0/events/properties/toptypes/`;
  }

  buildQueryParams(options = {}) {
    return {
      project_id: options.projectId,
    };
  }

  buildRequestBody(options = {}) {
    const {
      eventName,
      datasetId,
      dataGroupId,
      includeCustom,
      includeDimensionProperties,
      includeHidden,
      workspaceId,
      useQueryCache = null,
    } = {
      eventName: null,
      datasetId: DATASET_MIXPANEL,
      dataGroupId: null,
      includeCustom: false,
      ...options,
    };
    /* eslint-disable camelcase */
    return JSON.stringify({
      limit: 1500,
      ...getEventParam(eventName),
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(includeCustom ? {include_custom: includeCustom} : {}),
      ...(includeDimensionProperties ? {include_dimension_props: includeDimensionProperties} : {}),
      ...(includeHidden ? {include_hidden: includeHidden} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(useQueryCache !== null ? {use_query_cache: useQueryCache} : {}),
    });
    /* eslint-enable camelcase */
  }

  processResponse(response) {
    return processProperties(response);
  }
}

export const eventPropertiesClient = new EventPropertiesClient();
